export default "__VITE_ASSET__B760xj$2__"